import { render, staticRenderFns } from "./TabCases.vue?vue&type=template&id=4953b716"
import script from "./TabCases.vue?vue&type=script&lang=js"
export * from "./TabCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports